import React from 'react'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Row, Divider, Col, Form, Typography, Button } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { currencyFormat, method } from '../../services/Utils'
const { Paragraph } = Typography

const INIT = {
    payments: [],
    is_credit: false,
}

const ReportOrdersShowContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [isOpen, setIsOpen] = React.useState(false)
    const handleClose = React.useCallback(() => setIsOpen(false), [])

    const getData = () => {
        setloading(true)
        API.get(`/api/orders/${match.params.id}?with=user`)
            .then(response => {
                setData(response.data)
                setloading(false)
            })
            .catch(error => {
                console.log(error)
                setloading(false)
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    return (
        <Segment loading={loading}>
            <Divider>Detalle {data.is_credit ? 'de la venta a credito' : ' de la venta'}</Divider>
            <Form style={{ maxWidth: '500px', margin: 'auto' }} className="form-border">
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>ID único:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.unique_id}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Cliente:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>
                            {`${data.customer_first_name} ${data.customer_last_name} (${data.customer_email})`}{' '}
                        </Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Subtotal:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {currencyFormat(data.base_sub_total)}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Descuento:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {currencyFormat(data.discount_amount)}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Subtotal Neto:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {currencyFormat(data.sub_total)}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Impuestos:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {currencyFormat(data.tax_amount)}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Total:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {currencyFormat(data.grand_total)}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Fecha:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.captured_at ? moment(data.captured_at).format('DD/MM/YYYY hh:mm A') : ''}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Pagos:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {data.payments
                            ? data.payments.map(item => (
                                  <Paragraph strong>
                                      {method(item.payment_method)} ({currencyFormat(item.amount)})
                                  </Paragraph>
                              ))
                            : null}
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Pagar:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Link
                            to={`/orders/pay/${match.params.id}`}
                            style={{ marginLeft: '5px' }}
                        >
                            <Button
                                icon="dollar"
                                disabled={!data.is_credit}
                            >
                                Pagar
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to={data.is_credit ? '/report/credit' : '/report/sales'} style={{ marginLeft: '5px' }}>
                        <Button icon="arrow-left">Regresar</Button>
                    </Link>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default ReportOrdersShowContainer
